/**
 * 通用的全局常量
 */

// 作品类型
export enum AppType {
  // 普通作品类型（根据组件素材自由组合搭建页面）
  normal = 'normal',
  // 活动类型（根据活动模板生成的作品）
  activity = 'activity',
}
